import { TitleContainer } from "@/components/HeaderContainer";
import { LightThemedButton, ThemedButton } from "@/components/ThemedButton";
import useLoginSession from "@/hooks/useLoginSession";
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";

function ModalWithdrawalDesc() {
	const { isLoginBySession } = useLoginSession();

	let navigate = useNavigate();
	const location = useLocation();
	const { learner_id } = location.state?.data || location.state || {};

	if (!learner_id) {
		navigate("/course");
	}

	const handleBack = () => {
		if (isLoginBySession && window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({
					status: "error",
				}),
			);
		} else {
			navigate(-1);
		}
	};

	return (
		<div className='reschedule_main_container'>
			<TitleContainer>Withdrawal</TitleContainer>
			<div>
				<Card className='mt-2'>
					<CardBody>
						<p className='fs18 text-fca-dark'>
							Any withdrawal/cancellation/no-show for confirmed enrolments must be submitted at
							least seven (7) days prior to course date with supporting documents.In the event of
							withdrawal/cancellation/no-show without submission of a withdrawal form containing
							supporting documents, trainee(s) will be liable to pay the full course fees. Please
							note that government funding is not applicable for withdrawal/cancellation/no-show and
							the penalty fees may need to be paid via cash/bank transfer.
						</p>
						<Col md='12' xl='12'>
							<div className='flex justify-content-end gap-1 mb-4 mt-6'>
								<LightThemedButton onClick={handleBack}>Back</LightThemedButton>
								<ThemedButton
									component={Link}
									to='/course/withdrawal'
									state={{
										learner_id: learner_id,
									}}>
									Proceed to Withdrawal
								</ThemedButton>
							</div>
						</Col>
					</CardBody>
				</Card>
			</div>
		</div>
	);
}

export default ModalWithdrawalDesc;
